module.exports = __webpack_public_path__ + "static/media/imgexample.1237be4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/imgexample.png
// module id = 1058
// module chunks = 0